import { HeavyVehicleFlowType } from "@keita/lanepatrol-sdk";
import { CreateOrUpdateSimulationLane } from "./SimulationLane";
import { PhotoSource } from "../../cra/models/CraNode";
import { SimulationLane } from "./SimulationLane";
import { HlaWayType } from "./HlaWay";

export interface SimulationResponse {
  simulationWay: SimulationWay;
  simulationLanes: SimulationLane[];
}

export interface SimulationWay {
  id: string;
  surveyId: string;
  hlaWayId:string;
  name: string | null;
  type: HlaWayType;
  averageDailyTraffic: number | null;
  averageRoadSpeed: number | null;
  frontFacingLane: SimulationLane | null;
  backFacingLane: SimulationLane | null;
  heavyVehicleFlow: HeavyVehicleFlowType | null;
  lit: boolean;
  verified: boolean;
  createdAt: string;
  photo: {
    fileName: string;
    url: string | any;
    source: PhotoSource;
  } | null;
}

export interface UpdateSimulationWayPhoto {
  image: string;
  source: PhotoSource;
}

export interface UpdateSimulationWay {
  type: HlaWayType;
  averageDailyTraffic: number | null;
  averageRoadSpeed: number | null;
  heavyVehicleFlow: HeavyVehicleFlowType | null;
  lit: boolean;
  verified: boolean;
  frontFacingLane: CreateOrUpdateSimulationLane | null;
  backFacingLane: CreateOrUpdateSimulationLane | null;
  photo: UpdateSimulationWayPhoto | null;
}

export const buildEmptyUpdateSimulationWay = (): UpdateSimulationWay => ({
  type: HlaWayType.Unclassified,
  averageDailyTraffic: null,
  averageRoadSpeed: null,
  heavyVehicleFlow: null,
  lit: true,
  verified: false,
  frontFacingLane: null,
  backFacingLane: null,
  photo: null,
});

export const simulationWayToUpdate = (
  way: SimulationWay,
  lanes: SimulationLane[],
): UpdateSimulationWay => {
  const frontFacingLane = lanes.find((lane) => lane.frontFacing) ?? null;
  const backFacingLane = lanes.find((lane) => !lane.frontFacing) ?? null;
  return {
    type: way.type,
    averageDailyTraffic: way.averageDailyTraffic,
    averageRoadSpeed: way.averageRoadSpeed,
    heavyVehicleFlow: way.heavyVehicleFlow,
    lit: way.lit,
    verified: way.verified,
    frontFacingLane: simulationLaneToCreateOrUpdate(frontFacingLane),
    backFacingLane: simulationLaneToCreateOrUpdate(backFacingLane),
    photo: null,
  };
};

export const simulationLaneToCreateOrUpdate = (
  lane: SimulationLane | null,
): CreateOrUpdateSimulationLane | null =>
  lane
    ? {
        frontFacing: lane.frontFacing,
        adjacentFeaturesLeft: lane.adjacentFeaturesLeft,
        adjacentFeaturesRight: lane.adjacentFeaturesRight,
        flowDirection: lane.flowDirection,
        facilityType: lane.facilityType,
        facilityWidthPerDirection: lane.facilityWidthPerDirection,
        lightSegregation: lane.lightSegregation,
        tramOrTrainRails: lane.tramOrTrainRails,
      }
    : null;

export interface CreateSimulationWay {
  surveyId: string;
  hlaWayId: string;
  name: string;
  type: HlaWayType;
  averageDailyTraffic: number | null;
  averageRoadSpeed: number | null;
  heavyVehicleFlow: HeavyVehicleFlowType | null;
  lit: boolean;
  verified: boolean;
  frontFacingLane: CreateOrUpdateSimulationLane | null;
  backFacingLane: CreateOrUpdateSimulationLane | null;
}
